export const siteInfo = {
  name: 'g点网',
  fullName: 'g点网综合服务平台',
  slogan: '开启便捷网络体验',
  description: 'g点网是值得信赖的综合性网络平台，致力于为用户提供安全、便捷、高效的网络服务。平台集资讯浏览、功能使用、安全防护于一体，是您日常网络生活的得力助手。',
  founded: '2018',
  email: 'service@gpoint.com',
  phone: '400-888-9999',
  address: '北京市海淀区中关村科技园区',
  workingHours: '周一至周五 9:00 - 18:00',
  socialLinks: {
    weibo: 'https://weibo.com/gpoint',
    wechat: 'gpoint_net',
  },
  stats: {
    users: '500万+',
    articles: '10万+',
    satisfaction: '98.5%',
    years: '8',
  },
};